import { useQuery } from '@tanstack/react-query';
import eliteService from 'v2/services/elite';

function useElite() {
  return useQuery({
    queryKey: ['elite'],
    queryFn: eliteService.list
  });
}

export { useElite };
